import ZhfeAjax from '@/plugins/zhfeAjax'
import { strictExtend } from '@shared/utils/base/index.js'

const api = new ZhfeAjax({
  default: {
    method: 'POST',

    responseSuccessFn: function (res) {
      const data = res.data
      const respCommon = strictExtend({
        msg: '',
        ret: -1
      }, data.resp_common)

      delete data.resp_common

      return {
        resp_common: respCommon,
        ret: respCommon.ret,
        data
      }
    },

    responseFailFn: function (err) {
      return Promise.resolve({ ret: 9999, msg: err.message })
    }
  }
})

export default api
